/* @flow */
import * as React from 'react';

import Copy from 'components/Copy';
import AdminUpgradeInformationalPage from 'admin/components/AdminUpgradeInformationalPage';
import AdminUpgradeCompleteButton from 'admin/components/AdminUpgradeCompleteButton';

export default class AdminUpgradeCanadianOrganization extends React.Component<{}> {
  render() {
    return (
      <AdminUpgradeInformationalPage
        title="Thanks for your interest!"
        subtext={
          <Copy>
            <p>
              Remind provides customized quotes for Canadian organizations, and a member of our team
              will review your information and contact you to follow up.
            </p>
            <p>
              We’re looking forward to talking with you about how a Remind Plan can work for you!
            </p>
          </Copy>
        }
        action={<AdminUpgradeCompleteButton />}
      />
    );
  }
}
